import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { parseWallClockTime } from '../../shared/Helpers/timezones';

import { CustomAlert, CustomButton, Text } from '../../shared/uiComponents';
import { useScreenWidth } from '../../shared/Helpers/hooks';
import { formatClientName } from '../../shared/Helpers/functions';

import { clearDrafts, getSoapNotesUserDrafts } from '../../redux/State/clientSlice/soapNoteSlice';
import { DispatchProperties, useSelector } from '../../redux/store';

const OpenedNoteLabel = ({ x, index, onClose }: { index: number; onClose: () => void; x: any }) => {
	const navigate = useNavigate();

	const navigateNoteHandler = () => {
		const { id, client, sessionId } = x;
		navigate(
			`/soap-notes/info?clientId=${client?.id ? client.id : ''}&sessionId=${
				sessionId ? sessionId : ''
			}&reportId=${id ? id : ''}`,
		);
		onClose();
	};

	return (
		<div style={{ display: 'flex', gap: '16px' }} onClick={navigateNoteHandler}>
			<Text type="psm" style={{ wordBreak: 'unset' }} title={`${index + 1}: `} />
			{x.client && <Text type="psm" title={formatClientName(x.client.fullName, x.client.isElc)} />}
			<Text type="psm" title={parseWallClockTime(x.startTime).format('MM/DD/YYYY hh:mm A')} />
		</div>
	);
};

const SavedDraftsInfo = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const [open, setOpen] = useState<boolean>(false);
	const [pageSize, setPageSize] = useState<number>(8);
	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const userId = useSelector((state) => state.account.user.id);
	const availableSessions = useSelector((state) => state.soapNote.soapNotesDrafts);

	useEffect(() => {
		if (!userId || Boolean(availableSessions.query)) return;

		dispatch(
			getSoapNotesUserDrafts({
				userId,
				pageSize: `${pageSize}`,
			}),
		);
	}, [userId, availableSessions, pageSize, dispatch]);

	const loadMoreHandler = () => {
		dispatch(clearDrafts());
		setPageSize((prev) => prev + 8);
	};

	return (
		<>
			{availableSessions?.totalNumberOfItems ? (
				isMobile ? (
					<CustomButton title={`${availableSessions.totalNumberOfItems}`} onClick={() => setOpen(true)} />
				) : (
					<Text
						fontWeight="semiBold"
						onClick={() => setOpen(true)}
						title={`You have ${availableSessions.totalNumberOfItems} session${
							availableSessions.totalNumberOfItems > 1 ? 's' : ''
						} pending submission.`}
					/>
				)
			) : null}
			<CustomAlert
				open={open && Boolean(availableSessions.query)}
				title="Please complete drafts or submit missing notes."
				onClose={() => setOpen(false)}
				Content={({ onClose }) => (
					<>
						{availableSessions.query?.map((x, index) => (
							<OpenedNoteLabel x={x} index={index} key={index} onClose={onClose} />
						))}
						{availableSessions.hasNextPage && <Text title="Load More" onClick={loadMoreHandler} />}
					</>
				)}
			/>
		</>
	);
};

export default SavedDraftsInfo;
